import { render, staticRenderFns } from "./purse.vue?vue&type=template&id=7b8cf1d1&scoped=true&"
import script from "./purse.vue?vue&type=script&lang=js&"
export * from "./purse.vue?vue&type=script&lang=js&"
import style0 from "./purse.vue?vue&type=style&index=0&id=7b8cf1d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8cf1d1",
  null
  
)

export default component.exports